import { Link2 } from 'lucide-react';
import * as React from 'react';

import { Badge } from '@/components/ui/badge';
import type { DiscriminatedTaskExternalCmsUpdateStatusChangedEvent } from '@/services/api/generated/taskActivityService';

import { EventBody, EventContainer, EventHeader } from './EventPrimitives';

interface TaskExternalCmsUpdateStatusChangedEventProps {
  event: DiscriminatedTaskExternalCmsUpdateStatusChangedEvent;
  matterId: string;
}

export const TaskExternalCmsUpdateStatusChangedEvent: React.FC<
  TaskExternalCmsUpdateStatusChangedEventProps
> = ({ event, matterId }) => {
  const { payload, occurred_at, user, agent } = event;
  const { task, old: oldStatus, new: newStatus } = payload;

  // Format status
  const formatStatus = (status: string): string => {
    return status === 'UPDATED' ? 'Updated' : 'Not Updated';
  };

  const oldStatusLabel = formatStatus(oldStatus);
  const newStatusLabel = formatStatus(newStatus);

  // Determine variant for new status
  const newStatusVariant = newStatus === 'UPDATED' ? 'default' : 'outline';

  return (
    <EventContainer>
      <EventHeader
        icon={<Link2 size={20} />}
        title="External CMS Update Status Changed"
        timestamp={occurred_at}
        actor={user}
        agent={agent}
      />

      <EventBody>
        <div className="space-y-1.5">
          {/* External CMS Update Status Change */}
          <div className="flex items-center gap-2 text-xs mt-2">
            <span className="text-slate-600">External CMS:</span>
            <Badge variant="outline" className="line-through">
              {oldStatusLabel}
            </Badge>
            <span className="text-slate-400">→</span>
            <Badge variant={newStatusVariant}>{newStatusLabel}</Badge>
          </div>
        </div>
      </EventBody>
    </EventContainer>
  );
};

// Helper functions
